(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["under-sun-filter-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-under-sun-tabs]');
    if (!root) return;

    const scroller = root.querySelector('.under-sun-tabs__scroller');
    const tabs = [...root.querySelectorAll('[data-under-sun-filter]')];
    const panels = [...root.querySelectorAll('[data-under-sun-panel]')];
    const pageSize = 48;
    const pageByPanel = new WeakMap();

    if (scroller) {
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let horizontalGesture = false;

      scroller.addEventListener('touchstart', (event) => {
        const touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        startScrollLeft = scroller.scrollLeft;
        horizontalGesture = false;
      }, { passive: true });

      scroller.addEventListener('touchmove', (event) => {
        const touch = event.touches[0];
        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;

        if (!horizontalGesture && Math.abs(deltaX) > Math.abs(deltaY) + 4) {
          horizontalGesture = true;
        }

        if (!horizontalGesture) return;
        event.preventDefault();
        scroller.scrollLeft = startScrollLeft - deltaX;
      }, { passive: false });
    }

    function renderPagination(panel) {
      const cards = [...panel.querySelectorAll('[data-under-sun-card]')];
      const pagination = panel.querySelector('[data-under-sun-pagination]');
      if (!pagination) return;

      const totalPages = Math.max(1, Math.ceil(cards.length / pageSize));
      const currentPage = Math.min(pageByPanel.get(panel) || 1, totalPages);
      pageByPanel.set(panel, currentPage);
      const firstIndex = (currentPage - 1) * pageSize;
      const lastIndex = firstIndex + pageSize;

      cards.forEach((card, index) => {
        card.hidden = index < firstIndex || index >= lastIndex;
      });

      pagination.replaceChildren();
      pagination.hidden = totalPages <= 1;
      if (totalPages <= 1) return;

      const addButton = (label, targetPage, disabled, isCurrent = false) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.disabled = disabled;
        button.className = 'under-sun-pagination__button';
        if (isCurrent) {
          button.classList.add('is-current');
          button.setAttribute('aria-current', 'page');
        }
        button.addEventListener('click', () => {
          pageByPanel.set(panel, targetPage);
          renderPagination(panel);
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        pagination.appendChild(button);
      };

      addButton('Previous', Math.max(1, currentPage - 1), currentPage === 1);
      for (let page = 1; page <= totalPages; page += 1) {
        addButton(String(page), page, false, page === currentPage);
      }
      addButton('Next', Math.min(totalPages, currentPage + 1), currentPage === totalPages);
    }

    async function loadRemainingProducts(panel) {
      let nextLink = panel.querySelector('[data-under-sun-next]');
      const grid = panel.querySelector('[data-under-sun-grid]');
      if (!nextLink || !grid) return;

      panel.dataset.underSunLoading = 'true';

      try {
        while (nextLink) {
          const response = await fetch(nextLink.href, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to load the next product page');

          const parsedHTML = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fetchedPanel = parsedHTML.getElementById(panel.id);
          if (!fetchedPanel) break;

          fetchedPanel.querySelectorAll('[data-under-sun-card]').forEach((card) => {
            grid.appendChild(card);
          });

          nextLink = fetchedPanel.querySelector('[data-under-sun-next]');
        }

        panel.querySelector('[data-under-sun-next]')?.remove();
        renderPagination(panel);
        window.dispatchEvent(new Event('checkImages'));
        if (window.theme && theme.LazyImage) theme.LazyImage.update();
      } catch (error) {
        console.error('Under the Sun products could not be fully loaded.', error);
      } finally {
        delete panel.dataset.underSunLoading;
      }
    }

    function activate(key, focusTab = false) {
      tabs.forEach((tab) => {
        const active = tab.dataset.underSunFilter === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focusTab) tab.focus();
      });

      panels.forEach((panel) => {
        const active = panel.dataset.underSunPanel === key;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) {
          pageByPanel.set(panel, 1);
          renderPagination(panel);
        }
      });

      window.dispatchEvent(new Event('checkImages'));
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.underSunFilter));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const currentIndex = tabs.indexOf(tab);
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextTab = tabs[(currentIndex + direction + tabs.length) % tabs.length];
        activate(nextTab.dataset.underSunFilter, true);
      });
    });

    panels.forEach((panel) => {
      renderPagination(panel);
      loadRemainingProducts(panel);
    });
    if (tabs[0]) activate(tabs[0].dataset.underSunFilter);
  })();

  } catch(e) { console.error(e); }
})();
})();
